var React = require('react');

function HeaderNav (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M47.2001 27.7L23.7 20.7L0.300049 27.7","stroke":"#929497","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M47.2001 18.3L23.7 11.4L0.300049 18.3","stroke":"#929497","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M47.2001 9L23.7 2L0.300049 9","stroke":"#929497","strokeWidth":"2","key":2})]);
}

HeaderNav.defaultProps = {"width":"48","height":"29","viewBox":"0 0 48 29","fill":"none"};

module.exports = HeaderNav;

HeaderNav.default = HeaderNav;
